import moment from 'moment';

import { ChildInputType, Enum } from '~/data/enums';

export const isActiveOrNonActiveAndSelected = (
  jsonEnum: Enum,
  selectedCode: string,
): boolean => {
  return jsonEnum.isActive !== false || jsonEnum.code === selectedCode;
};

export const isMatchingCountry = (
  jsonEnumCountries: ChildInputType[] | string[] | undefined,
  countryCode: string,
): boolean => {
  return (
    jsonEnumCountries === undefined ||
    jsonEnumCountries
      .map((c) => (typeof c === 'string' ? c : c.value))
      .find((c) => c === countryCode) !== undefined
  );
};

export const isMatchingOrSelectedCountry = (
  jsonEnum: Enum,
  countryCode: string,
  selectedCode: string,
) => {
  return (
    jsonEnum.countries === undefined ||
    jsonEnum.countries.length === 0 ||
    jsonEnum.code === selectedCode ||
    isMatchingCountry(jsonEnum.countries, countryCode)
  );
};

export const filterEnumsByCountry = (
  jsonEnumValues: Enum[],
  selectedCode: string,
  countryCode: string,
): Enum[] => {
  return jsonEnumValues
    .filter((e) => {
      return (
        isActiveOrNonActiveAndSelected(e, selectedCode) &&
        isMatchingOrSelectedCountry(e, countryCode, selectedCode)
      );
    })
    .map(function (e) {
      if (
        e.isActive === false ||
        !isMatchingCountry(e.countries, countryCode)
      ) {
        e['enumWarn'] = true;
      }
      return e;
    });
};

export const jsIsEmpStatus = (
  empStatus: string,
  strStatus: string,
): boolean => {
  return empStatus === strStatus;
};

export const sortEnumLables = (currentLabel: Enum, nextLabel: Enum): number => {
  const curr = currentLabel.seq ? currentLabel.seq : -1;
  const next = nextLabel.seq ? nextLabel.seq : -1;
  if (curr < next) {
    return -1;
  }

  if (curr > next) {
    return 1;
  }

  return 0;
};

//Converts the date string from ISO format (yyyy-mm-dd) to EU format (d.m.yyyy).
export const jsToEUDate = (strISODate: string): string => {
  if (moment(strISODate, 'DD.MM.YYYY', true).isValid()) {
    return strISODate;
  }
  if (strISODate === undefined || strISODate === '') {
    return '';
  }
  return moment(strISODate, 'YYYY-MM-DD').format('DD.MM.YYYY');
};

export const jsNumber = (vNumber: number): string => {
  if (vNumber === undefined) {
    return '';
  } else {
    return vNumber.toString();
  }
};

export const jsSelectName = (fieldEnums: Enum[], code: string): string => {
  if (code === undefined || code === '') return '';
  const oItem = fieldEnums.find((fenum) => fenum.code === code);
  return oItem ? oItem['name' as keyof object] : code;
};
